<template>
  <div class="account-tab-item__mob-filter" @click="onWrapperClick">
    <div class="account-tab-item__mob-filter-content">
      <div class="account-tab-item__mob-filter-head">
        <button class="account-tab-item__back-btn" @click="$emit('close')">
          <BaseSvg name="ico-arrow-light" class="_arrow" width=".4rem" height=".6rem"/>
          <span>{{ $tAccount('Back') }}</span>
        </button>
      </div>
      <div class="account-tab-item__mob-filter-group">
        <div class="account-tab-item__mob-filter-item">
          <div class="select-dropdown _left">
            <div class="select-dropdown__trigger-wrap">
              <button type="button" class="select-dropdown__trigger"
                      @click.prevent="showFilterDateRequest = true">
                <span>{{ $tAccount('Request date') }}</span>
                <BaseSvg v-if="true" class="select-dropdown__trigger-arrow" name="ico-arrow"/>
              </button>
              <div v-if="false" class="select-dropdown__selected">
                <span @click.prevent="showFilterDateRequest = true"
                      class="select-dropdown__selected-text"
                >some {{ $tAccount('and more') }} 5</span>
                <span @click="onClear" class="select-dropdown__selected-del">
                  <BaseSvg name="ico-close"/>
                </span>
              </div>
            </div>
            <transition name="dropdown">
              <div
                  v-if="showFilterDateRequest"
                  v-click-out="() => this.showFilterDateRequest = false"
                  class="select-dropdown__dropdown"
              >
                <button
                    type="button"
                    class="select-dropdown__close"
                    @click.prevent="showFilterDateRequest = false"
                >
                  <BaseSvg
                      name="ico-close"
                      width=".8rem"
                      height=".8rem"
                  />
                </button>

                <div class="select-dropdown__options">
                  date
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="account-tab-item__mob-filter-item">
          <AccountTabItemSelectDropdown :name="filters.methods.name"
                                        filterKey="methods"
                                        :values="filters.methods.values"
                                        :selectedProperties="filterSelectedProperties['methods']"
                                        :isChecked="isChecked"
                                        :onToggleFilter="onToggleFilter"
                                        :onClear="onClear"
                                        class="_left"/>
        </div>
        <div class="account-tab-item__mob-filter-item">
          <div class="select-dropdown _left">
            <div class="select-dropdown__trigger-wrap">
              <button type="button" class="select-dropdown__trigger"
                      @click.prevent="showFilterStatus = true">
                <span>{{ $tAccount('Status') }}</span>
                <BaseSvg v-if="true" class="select-dropdown__trigger-arrow" name="ico-arrow"/>
              </button>

              <div v-if="false" class="select-dropdown__selected">
                <span @click.prevent="showFilterStatus = true"
                      class="select-dropdown__selected-text"
                >some {{ $tAccount('and more') }} 5</span>
                <span @click="onClear" class="select-dropdown__selected-del">
                  <BaseSvg name="ico-close"/>
                </span>
              </div>
            </div>
            <transition name="dropdown">
              <div
                  v-if="showFilterStatus"
                  v-click-out="() => this.showFilterStatus = false"
                  class="select-dropdown__dropdown"
              >
                <button
                    type="button"
                    class="select-dropdown__close"
                    @click.prevent="showFilterStatus = false"
                >
                  <BaseSvg
                      name="ico-close"
                      width=".8rem"
                      height=".8rem"
                  />
                </button>

                <div class="select-dropdown__options filter-checkbox _short">
                  <ul class="filter-checkbox__list">
                    <li>
                      <BaseCheckbox label="rdcz adasd asd"/>
                    </li>
                    <li>
                      <BaseCheckbox label="rdcz adasd asd"/>
                    </li>
                  </ul>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="account-tab-item__mob-filter-item">
          <div class="select-dropdown _left">
            <div class="select-dropdown__trigger-wrap">
              <button type="button" class="select-dropdown__trigger"
                      @click.prevent="showFilterDatePayment = true">
                <span>{{ $tAccount('Payment date') }}</span>
                <BaseSvg v-if="true" class="select-dropdown__trigger-arrow" name="ico-arrow"/>
              </button>
              <div v-if="false" class="select-dropdown__selected">
                <span @click.prevent="showFilterDatePayment = true"
                      class="select-dropdown__selected-text"
                >some {{ $tAccount('and more') }} 5</span>
                <span @click="onClear" class="select-dropdown__selected-del">
                  <BaseSvg name="ico-close"/>
                </span>
              </div>
            </div>
            <transition name="dropdown">
              <div
                  v-if="showFilterDatePayment"
                  v-click-out="() => this.showFilterDatePayment = false"
                  class="select-dropdown__dropdown"
              >
                <button
                    type="button"
                    class="select-dropdown__close"
                    @click.prevent="showFilterDatePayment = false"
                >
                  <BaseSvg
                      name="ico-close"
                      width=".8rem"
                      height=".8rem"
                  />
                </button>

                <div class="select-dropdown__options">
                  date
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AccountTabItemSelectDropdown from './AccountTabItemSelectDropdown'

  export default {
    name: 'AccountTabItemWithdrawHeaderMobile',
    components: {
      AccountTabItemSelectDropdown
    },
    props: {
      filters: Object,
      isChecked: Function,
      onToggleFilter: Function,
      onClear: Function,
      filterSelectedProperties: Object
    },
    data() {
      return {
        showFilterDate: false,
        showFilterStatus: false,
        showFilterDatePayment: false,
        showFilterDateRequest: false,
      }
    },
    methods: {
      onWrapperClick(e) {
        if (e.target === this.$el) {
          this.$emit('close')
        }
      }
    }
  }
</script>

<style lang="less">

</style>